/**
 * Card Statefull Component
 */
import { getBinFromCreditCardNumber } from "@kushki/js/lib/service/UtilsService";
import { CommissionConfigurationRequest } from "@kushki/js/lib/types/remote/commission_configuration_request";
import { SecureOtpRequest } from "@kushki/js/lib/types/secure_otp_request";
import { SubscriptionTokenRequest } from "@kushki/js/lib/types/subscription_token_request";
import { TokenRequest } from "@kushki/js/lib/types/token_request";
import { CommissionsDetailComponent } from "components/CommissionsDetailView/CommissionsDetailComponent";
import { DeferredOptionsComponent } from "components/DeferredOptions/DeferredOptionsComponent";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { FooterImageComponent } from "components/UI/FooterImageComponent/FooterImageComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import { VoucherViewComponent } from "components/VoucherView/VoucherViewComponent";
import { OtpContainer } from "components/WaitingView/OtpComponent";
import { OtpExceededRetriesContainer } from "components/WaitingView/OtpExceededRetriesComponent";
import {
  deleteErrorMessage,
  getCardBrand,
  getCardToken,
  getCommissionsConfig,
  getListBrandsLogosMerchant,
  getSubscriptionCardToken,
  hideModal,
  resetCardState,
  setDirty,
  setShowCommissionsDetail,
  showNesterErrorModal,
  updateEmailValidity,
  updateInput,
  updateOtpValue,
  validateOtp,
} from "containers/Card/store/Actions";
import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import { get } from "lodash";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getUrlIconBrand,
} from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { MessengerParams } from "types/remote/messenger_params";
import { ITransferAmount } from "types/transfer_amount";

/**
 * CardComponent Class
 */
class Card extends React.Component<CardState & LocalizeContextProps, object> {
  private cardFormRef: React.RefObject<HTMLFormElement> = React.createRef();
  private inputCard: IInputProps | null;
  private showDeferred: boolean = true;
  private showCardDocumentation: boolean;

  constructor(props: CardState & LocalizeContextProps) {
    super(props);
    this.inputCard = null;
    this.showCardDocumentation = this.props.currency === CurrencyEnum.COP;
    this.props.addTranslation(this.props.translation);
    this._cardNumberHandler = this._cardNumberHandler.bind(this);
    this._expDateHandler = this._expDateHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
    this._genericInputHandler = this._genericInputHandler.bind(this);
    this._charge = this._charge.bind(this);
    this._validateOtp = this._validateOtp.bind(this);
    this._getBrandCard = this._getBrandCard.bind(this);
    this._getCardsMerchant = this._getCardsMerchant.bind(this);
    this._handleCommissionsDetailClick = this._handleCommissionsDetailClick.bind(
      this
    );
    this.showDeferred = this._checkEnableDeferred(
      get(window, "location.pathname", "")
    );
  }

  public componentDidMount(): void {
    this.props.updateEmailValidity();

    const body: CommissionConfigurationRequest = {
      totalAmount: this.props.configAmount,
      currency: this.props.currency,
    };

    this.props.getCommissionConfig(body);

    this._getCardsMerchant();
  }

  // Charge
  public componentDidUpdate(): void {
    // istanbul ignore next
    if (
      this.props.token !== undefined &&
      (this.props.waitingViewEnabled === false ||
        this.props.otpState === true) &&
      this.props.showVoucher === false
    ) {
      const params: MessengerParams = {
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.CARD,
      };

      this.props.hideModal();
      this._charge(params);

      return;
    }

    if (this.inputCard !== null && this.inputCard.hasOwnProperty("classes")) {
      const classes: string[] = ["input", "input-cardNumber"];

      this.inputCard.classContainer = "inputContainer cardNumber-input section";
      this.inputCard.classes = classes;

      if (this.props.brand.length > 0) {
        this.inputCard.classContainer = "inputContainer section";
        this.inputCard.classes = ["input", this.props.brand];
        this.inputCard.card = {
          name: this.props.brand,
          urlIcon: getUrlIconBrand(
            this.props.brand,
            this.props.listBrandsLogosMerchant
          ),
        };
        this.props.onChangeInput(this.inputCard);
      }
    }

    if (
      this.props.secureServiceId !== undefined &&
      this.props.otpValue !== undefined &&
      this.props.failOtpMessage === undefined
    ) {
      this._validateOtp(this.props.secureServiceId, this.props.otpValue);
      this.props.updateOtpValue(undefined);

      return;
    }

    if (this.props.failOtpMessage !== undefined) {
      this.props.showNesterErrorModal();
      this.props.deleteErrorMessage();

      return;
    }

    return;
  }

  // tslint:disable-next-line
  public render(): React.ReactNode {
    return (
      <form
        onSubmit={this._submitHandler}
        autoComplete="off"
        noValidate={true}
        ref={this.cardFormRef}
      >
        <VoucherViewComponent />
        <ErrorMessage />
        {!this.props.showWaitModal ? (
          <div id="card-details-box">
            {this.props.listBrandsLogosMerchant.length > 0 ? (
              <FooterImageComponent
                icons={this.props.listBrandsLogosMerchant}
              />
            ) : null}
            <Row className="mb-20">
              <Col xs={12}>
                <Input
                  {...this.props.cardHolder}
                  change={this._genericInputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={12}>
                <Input
                  {...this.props.cardNumber}
                  change={this._cardNumberHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={6} className="pr-8">
                <Input
                  {...this.props.expDate}
                  change={this._expDateHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs={6} className="pl-8">
                <Input
                  {...this.props.cardCVC}
                  change={this._genericInputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
            {this.showDeferred ? <DeferredOptionsComponent /> : null}
          </div>
        ) : (
          <div id="otp-card">
            {this.props.exceededRetries === true ? (
              <OtpExceededRetriesContainer />
            ) : (
              <OtpContainer />
            )}
          </div>
        )}
        {this.props.hasCommission ? (
          <>
            <div>
              <Button
                id="commissionsDetailLinkButton"
                className="linkButton"
                color="link"
                onClick={this._handleCommissionsDetailClick}
              >
                <Translate id="commission.link" />
              </Button>
            </div>
            <CommissionsDetailComponent />
          </>
        ) : null}
        {!this.props.showWaitModal ? (
          <PayButton
            isValid={this.props.isValid}
            totalAmount={
              Number(this.props.configAmount) +
              this.props.commissionConfig.totalAmount
            }
            isSubscription={this.props.is_subscription}
            currency={this.props.currency}
            disable={this.props.disablePayButton}
          />
        ) : null}
        <Footer
          showLanguajeToggle={this.props.isLanguageToggleAvailable}
          showCardDocumentation={this.showCardDocumentation}
        />
      </form>
    );
  }

  private _genericInputHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.valid = checkValidity(value, new_input.rules);
    new_input.value = value;

    this.props.onChangeInput(new_input);

    return;
  }

  private _checkEnableDeferred(path: string): boolean {
    switch (path.replace(/\//g, "")) {
      case "credit_card": {
        this.props.resetCardState();

        return true;
      }

      case "debit_card": {
        this.props.resetCardState();

        return false;
      }
      default:
        return true;
    }
  }

  private _cardNumberHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    if (value.length === 9 || value.length > 18) this._getBrandCard(value);

    new_input.valid = checkValidity(value, new_input.rules);
    new_input.value = value;

    this.inputCard = new_input;

    this.props.onChangeInput(new_input);
  }

  private _getBrandCard(cardBin: string): void {
    this.props.cardBrand(getBinFromCreditCardNumber(cardBin));
  }

  private _getCardsMerchant(): void {
    this.props.getCardsMerchant();
  }

  private _expDateHandler(id: string, value: string): void {
    const new_input: IInputProps = { ...this.props[id] };
    const arr: RegExpMatchArray = value.split("/");

    switch (true) {
      case parseInt(arr[0], 10) > 12:
        arr[0] = "12";
        break;
      case arr[0] === "00":
        arr[0] = "01";
        break;
      case arr[1] === "00":
        arr[1] = "01";
        break;
      default:
        break;
    }

    new_input.value = arr.join("/");
    new_input.valid = checkValidity(value, new_input.rules);
    this.props.onChangeInput(new_input);
  }

  // Token
  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    const date: string[] = this.props.expDate.value.split(
      this.props.expDate.separator
    );
    const body: TokenRequest = {
      card: {
        cvc: get(this.props, "cardCVC.value", undefined),
        expiryMonth: parseInt(date[0], 10).toString(),
        expiryYear: date[1],
        name: this.props.cardHolder.value,
        number: this.props.cardNumber.value
          .split(this.props.cardNumber.separator)
          .join(""),
      },
      currency: this.props.currency,
      isDeferred: this.props.isDeferred,
      amount: this.props.configAmount,
    };

    if (this.props.isDeferred) {
      body.isDeferred = this.props.deferredOptionsComponent.valid;
      if (this.props.currency === CurrencyEnum.CLP)
        body.months = Number.parseInt(
          this.props.deferredOptionsComponent.monthsSelect.value,
          undefined
        );
    }

    if (!this.props.is_subscription) this.props.tokens(body);
    else this.props.tokens_subscription(body);
  }

  private _validateOtp(secureServiceId: string, otpValue: string): void {
    this.props.validateOtp({ secureServiceId, otpValue: otpValue });
  }

  private _charge(params: MessengerParams): void {
    if (this.props.isDeferred)
      params.deferredOptions = {
        type: this.props.deferredOptionsComponent.deferredTypeSelect.value,
        months: this.props.deferredOptionsComponent.monthsSelect.value,
        monthsOfGrace:
          this.props.deferredOptionsComponent.monthsOfGraceSelect.inputItems
            .length === 0
            ? undefined
            : this.props.deferredOptionsComponent.monthsOfGraceSelect.value,
      };
    // Charge
    sendParametersToParent(params);
  }

  private _handleCommissionsDetailClick(): void {
    this.props.onShowCommissionsDetail();
  }
}

const mapStateToProps: (state: CajitaStore) => CardState = (
  state: CajitaStore
): CardState => ({
  ...state.card,
  is_subscription: state.config.is_subscription,
  configAmount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : state.config.amount,
  currency: state.config.currency,
  showWaitModal: state.card.waitingViewEnabled,
  otpState: state.card.otpState,
  otpErrorMessage: state.card.failOtpMessage,
  brand: state.card.brand,
  isLanguageToggleAvailable: true,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): CardAction => dispatch(setDirty(payload)),
  tokens: (payload: TokenRequest): void => dispatch(getCardToken(payload)),
  cardBrand: (binNumber: string): void => dispatch(getCardBrand(binNumber)),
  getCardsMerchant: (): void => dispatch(getListBrandsLogosMerchant()),
  tokens_subscription: (payload: SubscriptionTokenRequest): void =>
    dispatch(getSubscriptionCardToken(payload)),
  getCommissionConfig: (payload: CommissionConfigurationRequest): void =>
    dispatch(getCommissionsConfig(payload)),
  onShowCommissionsDetail: (): CardAction =>
    dispatch(setShowCommissionsDetail(true)),
  validateOtp: (payload: {
    secureServiceId: string;
    otpValue: string;
  }): void => {
    const otp_request: SecureOtpRequest = {
      secureServiceId: payload.secureServiceId,
      otpValue: payload.otpValue,
    };

    dispatch(validateOtp(otp_request));
  },
  hideModal: (): void => dispatch(hideModal()),
  showNesterErrorModal: (): void => dispatch(showNesterErrorModal()),
  deleteErrorMessage: (): void => dispatch(deleteErrorMessage()),
  updateOtpValue: (payload: string): void => dispatch(updateOtpValue(payload)),
  updateEmailValidity: (): void => dispatch(updateEmailValidity(true)),
  resetCardState: (): void => dispatch(resetCardState()),
});

const CardComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<CardState & LocalizeContextProps>(Card));

export { CardComponent };



// WEBPACK FOOTER //
// ./src/containers/Card/CardComponent.tsx